var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2",attrs:{"min-width":"250","color":"oug","outlined":"","elevation":"24"},on:{"click":_vm.OpenChat}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }